<!-- <ng-container *ngIf="(conversations | async); let conversations"> -->
<div class="pagination conversationGroupList__pagination" *ngIf="allConversationsCount > perPage">
  <mat-paginator (page)="pageEvent = $event"
                  [length]="allConversationsCount"
                  [pageIndex]="page"
                  [pageSizeOptions]="pageSizeOptions"
                  [pageSize]="perPage"
                  (page)="pageChange($event)"></mat-paginator>
</div>
<mat-spinner class="conversationGroupList__loader" diameter="60" *ngIf="loading"></mat-spinner>
<div class="conversationGroupList__topToolbar topToolbar" *ngIf="!loading && !noConversationsInfo">
  <mat-checkbox class="topToolbar__selectAll" [(ngModel)]="selectAllCheckbox" (change)="selectAllConversations($event)">Select all</mat-checkbox>
  <div class="topToolbar__boxWhenSelect" *ngIf="selectedConvCount > 0">
    <span class="topToolbar__selectedCount" >
      Selected: {{selectedConvCount}}
    </span>
    <button  class="topToolbar__deleteBt" mat-flat-button color="primary" (click)="deleteSelectedConv()">
      Delete
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</div>

<div class="conversationGroupList__refreshSpinner" *ngIf="!loading && refreshingLastList">
  <mat-spinner diameter="20"></mat-spinner>
</div>

<ul class="conversationGroupList" [ngClass]="{'loading' : loading}" *ngIf="conversations">
  
  <li class="conversationGroupList__conversationItem--emptyList" *ngIf="(conversations.length == 0 || noConversationsInfo) && !loading">Inbox is empty</li>
  
  <ng-container *ngFor="let conversation of conversations; let i = index">
    <div class="adsContainer"
      *ngIf="mainService.advService.bannersEnabled && (!isPremium || !mainService.enableSubscription) && i + 1 != conversations.length && i % 8 == 0">
      <app-banner-zone-map [zoneType]="['Mobile-Ads', 'Mobile-Ads-2']" [isMobile]="true"></app-banner-zone-map>
    </div>

    <li class="conversationItem conversationGroupList__conversationItem showChecbox" #convList (click)="activateGroup(conversation); setReadedMessages(conversation)" [ngClass]="'conversation-'+conversation.conversationId" >
          <div class="conversationItem__wrap">
            <mat-checkbox #checboxList class="conversationGroupList__conversationSelect" [id]="conversation.conversationId" (click)="$event.stopPropagation()" (change)="selectConversation($event,i)"></mat-checkbox>
            <span class="conversationItem__date">
              <button class="conversationItem__newAd" *ngIf="conversation.hasNewMessages" mat-flat-button color="accent">NEW</button> 
              <button class="conversationItem__demoAd" *ngIf="showDemoAdInfo(conversation)" mat-stroked-button>DEMO AD</button> 
              {{conversation.creationDate.format("MM/DD/YYYY hh:mm A")}}&nbsp;
            </span>
            <div class="conversationItem__from"><strong>From: </strong><span class="conversationItem__nick">{{this.resolveConversationSenderNick(conversation)}}</span></div>
            <span class="conversationItem__title">
              <a [routerLink]="['/adv-detail/' + conversation.advertisementId + '/c/' + conversation.conversationKey ]" 
                (click)="navigateToAdv($event,conversation.advertisementId + '/c/' + conversation.conversationKey)">
                {{conversation.advTitle}}</a>
            </span>
            <button class="conversationItem__btnDelete" (click)="deleteConversation($event, conversation.conversationId, i)" mat-button style="float: right" title="Delete conversation">
              <mat-icon>delete</mat-icon>
            </button>
        <!--      <mat-panel-description>-->
        <!--        {{conversation.receiverEmail}}-->
        <!--      </mat-panel-description>-->
      </div>
    </li>
  </ng-container>
</ul>

<ng-template #noConversations>
  <div class="d-flex flex-fill align-items-center flex-column text-center align-self-stretch h-100">
    <div class="my-auto text-muted">
      no conversation
    </div>
  </div>
</ng-template>